export { default as SellPoint3Pdp } from './SellPoint3'
